(function () {
  'use strict';

  function initSaddlebagTabs(section) {
    var wrapper = section.querySelector('[id^="saddlebag-tabs-"]');
    if (!wrapper) return;

    var buttons = wrapper.querySelectorAll('.saddlebag-tabs__btn');
    var panels = wrapper.querySelectorAll('.saddlebag-tabs__panel');
    var mediaItems = section.querySelectorAll('.saddlebag-tabs__media-item');

    if (!buttons.length) return;

    function activateTab(targetId) {
      /* Deactivate all tabs */
      buttons.forEach(function (btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('tabindex', '-1');
      });

      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
        panel.setAttribute('hidden', '');
      });

      mediaItems.forEach(function (item) {
        item.classList.remove('is-active');
        if (item.tagName === 'VIDEO') {
          item.pause();
          item.currentTime = 0;
        }
      });

      /* Activate target tab */
      var activeBtn = wrapper.querySelector('[data-tab-target="' + targetId + '"]');
      var activePanel = wrapper.querySelector('#saddlebag-panel-' + targetId);
      var activeMedia = section.querySelector('[data-media-for="' + targetId + '"]');

      if (activeBtn) {
        activeBtn.classList.add('is-active');
        activeBtn.setAttribute('aria-selected', 'true');
        activeBtn.removeAttribute('tabindex');
      }

      if (activePanel) {
        activePanel.classList.add('is-active');
        activePanel.removeAttribute('hidden');
      }

      if (activeMedia) {
        activeMedia.classList.add('is-active');
        if (activeMedia.tagName === 'VIDEO') {
          activeMedia.play();
        }
      }
    }

    /* Click handler */
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(btn.getAttribute('data-tab-target'));
      });
    });

    /* Keyboard navigation (arrow keys within tab list) */
    buttons.forEach(function (btn, index) {
      btn.addEventListener('keydown', function (e) {
        var dir = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          dir = 1;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          dir = -1;
        } else if (e.key === 'Home') {
          e.preventDefault();
          buttons[0].focus();
          activateTab(buttons[0].getAttribute('data-tab-target'));
          return;
        } else if (e.key === 'End') {
          e.preventDefault();
          buttons[buttons.length - 1].focus();
          activateTab(buttons[buttons.length - 1].getAttribute('data-tab-target'));
          return;
        }

        if (dir !== 0) {
          e.preventDefault();
          var next = (index + dir + buttons.length) % buttons.length;
          buttons[next].focus();
          activateTab(buttons[next].getAttribute('data-tab-target'));
        }
      });
    });

    /* Set initial tabindex for non-active buttons */
    buttons.forEach(function (btn) {
      if (!btn.classList.contains('is-active')) {
        btn.setAttribute('tabindex', '-1');
      }
    });
  }

  /* Initialize all instances on page */
  function init() {
    var sections = document.querySelectorAll('.saddlebag-tabs-section');
    sections.forEach(initSaddlebagTabs);
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Support Shopify Theme Editor section reload */
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target;
      if (section.querySelector('.saddlebag-tabs-section')) {
        initSaddlebagTabs(section.querySelector('.saddlebag-tabs-section'));
      }
    });
  }
})();
